import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Timer } from "lucide-react";

const GROUPS = [
  ["Solleciti documenti (all'agente, poi al direttore)", [["doc_giorno_1", "1° sollecito all'agente", "giorni"], ["doc_giorno_2", "2° sollecito all'agente", "giorni"], ["doc_giorno_direttore", "Avviso al direttore", "giorni"]]],
  ["Notizie", [["notizia_contatto_giorni", "Contatta entro", "giorni"], ["notizia_ferma_agente", "Ferma → avviso all'agente", "giorni"], ["notizia_ferma_direttore", "Ferma → la vede il direttore", "giorni"]]],
  ["Segreteria", [["pratiche_ferme_giorni", "Pratica ferma dopo", "giorni"]]],
  ["Tempi massimi ticket", [["ticket_ore_urgente_appuntamento", "Urgente appuntamento", "ore"], ["ticket_ore_documenti", "Documenti", "ore"], ["ticket_ore_agenda", "Agenda", "ore"], ["ticket_ore_pubblicazione", "Pubblicazione", "ore"], ["ticket_ore_altro", "Altro", "ore"]]],
  ["Dopo la visita e sconti", [["visita_task_ore", "Task \"Prepara la proposta\" rosso dopo", "ore"], ["soglia_sconto_direttore", "Sconto provvigione che approva il direttore", "%"]]],
  ["Immobili fermi", [["fermo_giorni_mercato", "Fermo se sul mercato da oltre", "giorni"], ["fermo_giorni_visite", "Fermo se senza visite da", "giorni"]]],
];

export default function SoglieConfigCard() {
  const [c, setC] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/soglie").then((r) => setC(r.data)).catch(() => setC(null)); }, []);
  if (!c) return null;
  const save = async () => {
    setSaving(true);
    try { const r = await api.put("/settings/soglie", c); setC(r.data); toast.success("Soglie salvate"); }
    catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };
  return (
    <div className="card-immo p-5" data-testid="soglie-config-card">
      <div className="flex items-center gap-2 mb-1"><span className="w-8 h-8 rounded-xl bg-[#FC82ED]/15 text-[#FC82ED] flex items-center justify-center"><Timer size={16} /></span><h2 className="font-display font-bold text-base">Giorni e soglie</h2></div>
      <p className="text-xs text-[var(--muted)] mb-4">Valori predefiniti: 3/7/14 · 7/30/60 · 10 · 4h/24h/24h/48h/48h · 24h · 0,5%.</p>
      {GROUPS.map(([title, rows]) => (
        <div key={title} className="mb-4">
          <div className="text-[11px] font-bold uppercase tracking-wider text-[var(--muted)] mb-2">{title}</div>
          <div className="space-y-2">
            {rows.map(([k, label, suf]) => (
              <div key={k} className="flex items-center justify-between gap-3">
                <label className="text-sm flex-1">{label}</label>
                <div className="flex items-center gap-1.5">
                  <input data-testid={`soglia-${k}`} type="number" min="0" step={suf === "%" ? "0.1" : "1"} value={c[k] ?? ""}
                    onChange={(e) => setC({ ...c, [k]: e.target.value })}
                    className="w-20 px-2.5 py-2 rounded-lg border border-[var(--border)] text-base sm:text-sm text-right" />
                  <span className="text-xs text-[var(--muted)] w-10">{suf}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
      <button data-testid="soglie-salva" onClick={save} disabled={saving} className="w-full mt-2 py-2.5 rounded-xl bg-[#111111] text-white font-semibold text-sm disabled:opacity-50">{saving ? "Salvo…" : "Salva soglie"}</button>
    </div>
  );
}
